import React from 'react';
import { Icon } from './Icon.js';
export const IconBottleWine = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17 14H11V18H17", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M10 6H14", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M10 2H14V9.41604C15.7659 10.1876 17 11.9497 17 14V22H7V14C7 11.9497 8.2341 10.1876 10 9.41604V2Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBottleWine.js.map